import React from 'react';
import './NoticeMain.css';
import InfiniteScroll from 'react-infinite-scroller';
import Linker from '../../linker/Linker'
import * as path from '../../../../route/PathConfig'


const getSummary = (content) => {
  let summary = content.replaceAll(/(<([^>]+)>)/ig,"").replaceAll(/(\r|\n|&nbsp;)/ig," ");
  // let summary = content.replaceAll(/(<(/)?([a-zA-Z]*)(\\s[a-zA-Z]*=[^>]*)?(\\s)*(/)?>)/ig,"").replaceAll(/(\r|\n|&nbsp;)/ig,"");

  if(summary.length > 200) {
    summary = summary.substr(0, 200) + "...";
  }
  return summary;
}

const InputText = React.memo(props=>{
  return(
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
    />
  )})

const NoticeMain = (props) => {

  return (
    <div className="row featured-main">
      <div className="NoticeTitle">
        <span className="nielsen-navyBlack">공지사항</span>
        <div id="NoticeSearchBtn">
          {/* <input name="textfield3" type="text" className="box" id="textfield3" value="공지사항 검색 키워드 입력" size="30" /> */}
          <InputText placeholder="공지사항 키워드 검색" onChange={props.handleSearchInput} value={props.noticeFilter} name="textfield" type="text" className="noticeKwBox" id="textfield" size="35" />
          <a onClick={()=>props.handleSearchBtn()} className="button purple_line" style={{marginTop: "0px",marginLeft: "10px"}}>검색</a>
          <a onClick={()=>props.handleResetBtn()} className="button purple_line" style={{marginTop: "0px",marginLeft: "10px"}}>초기화</a>
          {props.userRole == 'ROLE_ADMIN' ?
            <Linker path={path.NOTICECREATE}>
              <a className="button purple" style={{marginTop: "0px", marginLeft: "10px"}}>작성</a>
            </Linker>
            : undefined
          }
        </div>
      </div>
      <div>
        <InfiniteScroll
          pageStart={0}
          initialLoad={false}
          loadMore={props.loadNotice}
          hasMore={props.hasMoreNotice}
          >
            <div className="NoticeTxt_box">
              <ul className="NoticeTxt">
                {props.filteredArray.map(item => {
                  return(
                    <li className="articleTitle">
                      <span className="NoticeLisDate">{item.createdDate}</span><br />
                      <Linker path={`${path.NOTICEPAGE}/${item.noticeID}`}>
                        <a href="" className="articleTitle">{item.title}</a>
                      </Linker>
                      <br />
                      {getSummary(item.content)}
                    </li>
                  )
                })}
              </ul>
            </div>
          </InfiniteScroll>
      </div>
    </div>
  )
}

export default NoticeMain;